import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgLockIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M28.8 6.4h6.4a3.2 3.2 0 0 1 3.2 3.2V16H25.6V9.6a3.2 3.2 0 0 1 3.2-3.2M41.6 16V9.6a6.4 6.4 0 0 0-6.4-6.4h-6.4a6.4 6.4 0 0 0-6.4 6.4V16h-9.6a3.2 3.2 0 0 0-3.2 3.2v32a3.2 3.2 0 0 0 3.2 3.2h38.4a3.2 3.2 0 0 0 3.2-3.2v-32a3.2 3.2 0 0 0-3.2-3.2zm-28.8 3.2h38.4v32H12.8zM32 28.8a3.2 3.2 0 1 0 0 6.4 3.2 3.2 0 0 0 0-6.4M25.6 32a6.4 6.4 0 1 1 8 6.198V44.8h-3.2v-6.602A6.4 6.4 0 0 1 25.6 32"
    />
  </svg>
)
export default SvgLockIcon
